<template>
  <div class="not-found-page">
      <img
        :src="notFound"
        alt="not_found"
        class="img"
      >
      <div class="info">
        <span class="title">404</span>
        <span class="text">{{$t('page_404.index.noPage')}}</span>
        <a class="back" @click="$router.go(-1)">{{$t('page_404.index.backPage')}}</a>
      </div>
  </div>
</template>
<script>
import notFount from "@/assets/not_found.png";
export default {
  name: "page404",
  data() {
    return {
      notFound: notFount
    };
  }
};
</script>
<style lang="scss" scoped>
.not-found-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .img {
      width: 320px;
      height: auto;;
  }
  .info {
    display: flex;
    flex-direction: column;
    margin-left: 80px;
    .title {
      font-size: 73px;
      color: #434e59;
      font-weight: bold;
    }
    .text {
      font-size: 20px;
      line-height: 28px;
      color: rgba(0, 0, 0, 0.45);
    }
    .back {
        margin-top: 16px;
    }
  }
}
</style>